<template>
  <div>
    <FormContent></FormContent>
  </div>
</template>

<script>
import FormContent from "../components/FormContent";

export default {
  name: "Content",
  components: {
    FormContent,
  },
};
</script>
